<ng-container [ngSwitch]="activeCodeStep">
  <ng-container *ngSwitchCase="CodeStep.Type">
    <app-commissioning-code-form
      (localModalAction)="onLocalModalAction($event)"
      (openQrScannerAction)="onOpenQrScannerAction()"
    ></app-commissioning-code-form>
  </ng-container>

  <ng-container *ngSwitchCase="CodeStep.Scan">
    <app-commissioning-scan-code
      (localModalAction)="onLocalModalAction($event)"
      (openCodeFormAction)="onOpenCodeFormAction()"
    ></app-commissioning-scan-code>
  </ng-container>

  <ng-container *ngSwitchCase="CodeStep.Loading">
    <app-commissioning-spinner
      [title]="'+SRC_COMMISSIONINGV2.MESSAGE_VERIFYING_DATA' | translate"
      [message]="'+SRC_COMMISSIONINGV2.MESSAGE_VERIFYING_DATA_DESCRIPTION' | translate"
    ></app-commissioning-spinner>
  </ng-container>

  <ng-container *ngSwitchCase="CodeStep.Result">
    <app-commissioning-code-form
      [summaryView]="true"
      (localModalAction)="onLocalModalAction($event)"
    ></app-commissioning-code-form>
  </ng-container>
</ng-container>
